import React from 'react';
import Icon from '../../../../Icon/Icon';
import s from './ProductTag.scss';

interface ProductTagProps {
  EFOProduct: boolean;
  isNew: boolean;
  marketplaceProduct: boolean;
  onlineExclusive: boolean;
}

const ProductTag: React.FC<ProductTagProps> = ({
  EFOProduct,
  isNew,
  marketplaceProduct,
  onlineExclusive,
}) => {
  const shouldShowTag =
    isNew || onlineExclusive || marketplaceProduct || EFOProduct;
  const displayOnlineExclusive = !marketplaceProduct && onlineExclusive;
  const displayEFO = !onlineExclusive && EFOProduct;
  const displayMarketPlace = !onlineExclusive && marketplaceProduct;
  const displayMarketPlaceExclusive = onlineExclusive && marketplaceProduct;
  const isNewAndOnlineExclusive = isNew && onlineExclusive;
  const isNewAndExpressFactory = isNew && EFOProduct;
  const isNewAndMarketplaceProduct = isNew && marketplaceProduct;
  const displayPipe =
    isNewAndOnlineExclusive ||
    isNewAndExpressFactory ||
    isNewAndMarketplaceProduct;

  if (shouldShowTag) {
    return (
      <div className={s.productTagsContainer}>
        {isNew && <span className={s.productTag}>New</span>}
        {displayPipe && (
          <span className={s.pipe}>
            <Icon icon="pipe" />
          </span>
        )}
        {displayOnlineExclusive && (
          <span className={s.productTag}>Online Only</span>
        )}
        {displayEFO && <span className={s.productTag}>Express Factory</span>}
        {displayMarketPlace && (
          <span className={s.productTag}>Express Marketplace</span>
        )}
        {displayMarketPlaceExclusive && (
          <span className={s.productTag}>EXP Marketplace Exclusive</span>
        )}
      </div>
    );
  }

  return null;
};

export default ProductTag;
